import Vue from 'vue';
import Locale from './../vue-i18n-locales.generated';
import env from '../env';
import IdleVue from 'idle-vue'

const lang = document.documentElement.lang.substr(0, 2);

import VueInternationalization from 'vue-i18n';
Vue.use(VueInternationalization);

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  events: ['mousemove', 'keydown', 'keyup', 'mousedown', 'touchstart'],
  idleTime: 3600000
});

const isDemo = location.host === 'demo.sourcelms.com'

const i18n = new VueInternationalization({
    locale: localStorage.getItem('language') ? localStorage.getItem('language') : isDemo ? 'en' : 'ua',
    messages: Locale
});

Object.defineProperty(Vue.prototype, '$locale', {
    get: function () {
        return i18n.locale
    },
    set: function (locale) {
        i18n.locale = locale;
        VeeValidate.Validator.localize(locale);
    }
});

import VeeValidate from 'vee-validate';
const phoneOrEmailRule = {
    getMessage(field, args) {
        return `The ${field} must be either a valid phone number or e-mail`;
    },
    validate(value, args) {

        const EMAILREG = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return EMAILREG.test(value) || value >= 10;
    }
};

VeeValidate.Validator.extend('phoneOrEmail', phoneOrEmailRule);
Vue.use(VeeValidate, {
    locale: localStorage.getItem('language') ? localStorage.getItem('language') : isDemo ? 'en' : 'ua',
    dictionary: {
        ru: {
            custom: {
                login: {
                    required: () => 'Введите логин',
                    phoneOrEmail: () => 'Введите корректный email или телефон'
                },
                phone_: {
                    required: () => 'Введите телефон',
                    length: () => 'Телефон должен содержать 12 цифр',
                    min: () => 'Телефон должен содержать не менее 12 цифр',
                },
                password: {
                    required: () => 'Введите пароль',
                },
                newPassword: {
                    required: () => 'Введите новый пароль',
                },
                confirmPassword: {
                    required: () => 'Введите новый пароль повторно',
                    confirmed: () => 'Введенные новые пароли не совпадают',
                },
                moodleLogin: {
                    required: () => 'Введите логин в Moodle',
                },
                moodlePassword: {
                    required: () => 'Введите пароль в Moodle',
                },
            }
        },
        en: {
            custom: {
                login: {
                    required: () => 'Enter login',
                    phoneOrEmail: () => 'Enter the correct email or phone'
                },
                phone_: {
                    required: () => 'Enter phone',
                    length: () => 'Phone number should contain 12 numbers',
                    min: () => 'Phone number should contain more than 10 numbers',
                },
                password: {
                    required: () => 'Enter password',
                },
                newPassword: {
                    required: () => 'Enter a new password',
                },
                confirmPassword: {
                    required: () => 'Re-enter new password',
                    confirmed: () => 'New passwords entered do not match',
                },
                moodleLogin: {
                    required: () => 'Enter login in Moodle',
                },
                moodlePassword: {
                    required: () => 'Enter your password in Moodle',
                },
            },
        },
        ua: {
            custom: {
                login: {
                    required: () => 'Введіть логін',
                    phoneOrEmail: () => 'Введіть коректний email або телефон'
                },
                phone_: {
                    required: () => 'Введіть телефон',
                    length: () => 'Телефон має містити 12 цифр',
                    min: () => 'Телефон має містити не менше 10 цифр',
                },
                password: {
                    required: () => 'Введіть пароль',
                },
                newPassword: {
                    required: () => 'Введіть новий пароль',
                },
                confirmPassword: {
                    required: () => 'Введіть новий пароль повторно',
                    confirmed: () => 'Введені нові паролі не збігаються',
                },
                moodleLogin: {
                    required: () => 'Введіть логін в Moodle',
                },
                moodlePassword: {
                    required: () => 'Введіть пароль в Moodle',
                },
            }
        },
    }
});


// Plugin for popup images and videos
import VueSilentbox from 'vue-silentbox'
Vue.use(VueSilentbox);

// Plugin for message links
import linkify from 'vue-linkify'
Vue.directive('linkified', linkify);


// V-html sanitize for protection from XSS
import VueSanitize from "vue-sanitize";
let defaultOptions = {
    allowedTags: ['a', 'b', 'u', 'strong'],
    allowedAttributes: {
        'a': ['href', 'target', 'class']
    }
};
Vue.use(VueSanitize, defaultOptions);

import moment from 'moment';

Vue.filter('formatDateMmDdYyyy', function (value) {
    if (value) {
        // console.log(Locale, Locale[i18n.locale], i18n.locale, "locales");
        let months = Locale[i18n.locale]['months'].split(',');
        let date = moment(String(value));
        return date.format('D') + ' ' + months[date.format('M') - 1] + ' ' + date.format('HH:mm:ss');
    }
});

Vue.filter('imgSrc', function (value) {
    if (value && value.match(/http:\/\/127.0.0.1:8000/g)) {
        return value.replace("http://127.0.0.1:8000", env.base_url)
    } else if (value && value !== '' && value !== null) {
        return value
    } else {
        return env.public_base + '/assets/images/person-icon.png'
    }
});

const router = new VueRouter({
    mode: 'history',
    routes,
    base: '/chat/'
});

router.beforeEach((to, from, next) => {
    store.dispatch('toggleSidebarLeft', false);
    next()
});

import App from './App.vue';
import store from './store/store';

import VueRouter from 'vue-router';
import { routes } from './routes';
Vue.use(VueRouter);

const app = new Vue({
    el: '#chats-app',
    router,
    store,
    i18n,
    render: h => h(App),
    created() {
        document.getElementById('chats-app')
    },
    onIdle() {
        window.location.reload(true);
    }
});
